/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/promotions/r/'>.
 * /r/-пагинация (§3.2)
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import Promotions from '@routes/Promotions';
import { getQueryClient } from '../../../providers/query';
import { promotionsQueryOptions } from '@queries/index';
import { getURLProps } from '@utils/setPagesUrl';
import { isContentNotFoundError } from '../../../api/contentNotFound';
import { assertValidListUrl } from '../../../ssrListParams';

export const Route = createFileRoute('/promotions/r/$')({
  /**
   * ЭТАП 2 — честный 404 несуществующей страницы списка акций
   * (/promotions/r/page/99999). Пагинации у списка нет (компонент всегда
   * рендерит page 1), поэтому это ОТДЕЛЬНАЯ серверная проверка легаси-URL:
   * findPromotionsAll на бэке зовёт checkPageHasItems и кидает
   * CONTENT_NOT_FOUND для пустой страницы -> notFound() -> HTTP 404 +
   * контент /404 без редиректа. page 1 не проверяем (пустой раздел — норма,
   * как и на бэке); клиентскую навигацию не блокируем.
   */
  loader: async ({ location }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    // Хвост /r/ обязан быть каноническим: чужие ключи, битые значения
    // и /r/page/1 — честный 404, см. src/ssrListParams.ts
    assertValidListUrl('promotions', location.pathname);
    const page =
      Number(getURLProps({ pathname: location.pathname }).page) || 1;
    if (page <= 1) {
      return;
    }
    try {
      await getQueryClient().ensureQueryData(
        promotionsQueryOptions({ setOrder: 'expired', page, setLimit: 30 })
      );
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: () => <CacheDataRoute component={Promotions} path='/promotions/r/' />
});
